// Adult Phonics Quiz — designed for teen/adult learners (target age ~23).
// Covers digraphs, blends, syllables, morphology, and vocabulary meaning.
export const QUIZ_QUESTIONS = [
  {
    id: "q1",
    question: "In the word \"phone\", what sound do the letters PH make together?",
    options: ["/p/", "/f/", "/ph/", "/h/"],
    correct: "/f/",
    note: "PH is a digraph pronounced /f/ — as in phone, graph, elephant.",
  },
  {
    id: "q2",
    question: "Which word rhymes with \"night\"?",
    options: ["Cat", "Kite", "Hat", "Ball"],
    correct: "Kite",
    note: "Night and kite share the long-i sound /aɪ/.",
  },
  {
    id: "q3",
    question: "The suffix \"-tion\" at the end of \"nation\" sounds like:",
    options: ["/tion/", "/shun/", "/ton/", "/chun/"],
    correct: "/shun/",
    note: "TION is a common suffix pronounced /shun/, as in nation, station, action.",
  },
  {
    id: "q4",
    question: "How many syllables are in the word \"rabbit\"?",
    options: ["1", "2", "3", "4"],
    correct: "2",
    note: "RAB-bit — two syllables, split between the double consonants (VC/CV).",
  },
  {
    id: "q5",
    question: "What sound do the letters SH make together?",
    options: ["/s/", "/h/", "/sh/", "/ch/"],
    correct: "/sh/",
    note: "SH is a consonant digraph — two letters, one sound: /sh/.",
  },
  {
    id: "q6",
    question: "The prefix \"un-\" in \"unhappy\" means:",
    options: ["Very", "Again", "Not", "Under"],
    correct: "Not",
    note: "UN- reverses or negates the root word: un + happy = not happy.",
  },
  {
    id: "q7",
    question: "Which of these is an open syllable (long vowel)?",
    options: ["Cat", "Hi", "Cup", "Bed"],
    correct: "Hi",
    note: "Open syllables end in a vowel and the vowel says its name — HI, GO, ME.",
  },
  {
    id: "q8",
    question: "The word \"read\" (past tense) has the same vowel sound as:",
    options: ["Seat", "Bed", "Bike", "Book"],
    correct: "Bed",
    note: "Past-tense READ rhymes with BED — short-e sound.",
  },
  {
    id: "q9",
    question: "In the word \"knight\", which letter is silent?",
    options: ["N", "I", "K", "G"],
    correct: "K",
    note: "K is silent before N at the start of a word — knight, knee, know.",
  },
  {
    id: "q10",
    question: "The Latin root \"port\" (as in transport, portable) means:",
    options: ["To see", "To carry", "To write", "To hear"],
    correct: "To carry",
    note: "PORT = to carry. Transport = carry across; portable = able to be carried.",
  },
];
